const STORAGE_KEY = 'korvai:wishlist';

function readWishlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeWishlist(handles) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  } catch (error) {
    /* localStorage unavailable (private mode, quota) — wishlist state won't persist this session */
  }
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.productHandle = this.dataset.productHandle;
    this.setState(readWishlist().includes(this.productHandle));
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const handles = readWishlist();
      const index = handles.indexOf(this.productHandle);
      const isNowActive = index === -1;
      if (isNowActive) {
        handles.push(this.productHandle);
      } else {
        handles.splice(index, 1);
      }
      writeWishlist(handles);
      this.setState(isNowActive);
      this.dispatchEvent(
        new CustomEvent('wishlist:change', {
          bubbles: true,
          detail: { handle: this.productHandle, active: isNowActive },
        })
      );
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.click();
    });
  }

  setState(isActive) {
    this.classList.toggle('is-active', isActive);
  }
}

customElements.define('wishlist-button', WishlistButton);
